import { useQuery } from "@tanstack/react-query";
import { getAllProduct } from "../api";

export const useGetAllProduct = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["PRODUCT-ALL"],
    queryFn: getAllProduct,
    select: ({ data }) => data,
  });

  return { product: data, isLoading };
};
